import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import CheckBoxField from '../formFields/CheckBoxField';
import SelectFieldForLoadCity from '../formFields/SelectFieldForLoadCity';
import SelectFieldForLoadState from '../formFields/SelectFieldForLoadState';
import SelectField from '../formFields/SelectField';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class ServiceAddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null,
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getAreaList();
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );
            }
        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        if(this.props.initialValues) {
            if(this.props.initialValues.statusCode === 403)
                return false;
            this.props.initialValues.mode=this.state.mode
        }

        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();

        var cityList = [];

        /* ----- find selected city  -----*/
        if(this.props.initialValues && this.state.mode == 'edit' && this.props.initialValues.state) {
            this.state.stateId = this.props.initialValues.state._id
        }

        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} خدمات</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="title"
                                component={TextField}
                                type="text"
                                label="عنوان"
                                placeholder="عنوان"
                            />
                            <Field
                                name="stateId"
                                component={SelectFieldForLoadState}
                                label="استان"
                                placeholder="استان"
                                list={stateList}
                                defaultValue={(this.props.initialValues && this.props.initialValues.state && this.props.initialValues.state._id ? this.props.initialValues.state._id : null)}
                                onChangeVal={(stateId) => { _self.setState({stateId : stateId})}  }
                            />
                            {((cityList && cityList.length > 0) || (this.state.mode == 'edit') )?
                                <Field
                                    name="cityId"
                                    component={SelectFieldForLoadCity}
                                    label="شهر"
                                    list={cityList}
                                    defaultValue={(this.props.initialValues && this.props.initialValues.city && this.props.initialValues.city._id ? this.props.initialValues.city._id : null)}
                                />
                            :null}
                            <Field
                                name="price"
                                component={TextField}
                                type="number"
                                label="مبلغ(ریال)"
                                placeholder="مبلغ"
                            />
                            <Field
                                name="commuting"
                                component={TextField}
                                type="number"
                                label="پورسانت شرکت(ریال)"
                                placeholder="پورسانت شرکت"
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/service/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default ServiceAddEditForm = reduxForm({
    form: 'addService',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(ServiceAddEditForm)
